import { NgModule } from '@angular/core';
import { RouterModule, Routes,PreloadAllModules } from '@angular/router';
import { LoginComponent } from './shared/component/login/login.component';
import { ForgotPasswordComponent } from '@shared/component/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from '@shared/component/reset-password/reset-password.component';
import { AuthGuard } from '@shared/guard/auth.guard';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent, canActivate: [AuthGuard] },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  {
    path: '',
    loadChildren: () =>import('./location-owner/location-owner.module').then((m) =>m.LocationOwnerModule)
  },
  { path: '**', redirectTo: 'landlord/overview' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'disabled',
      preloadingStrategy: PreloadAllModules
    }),
  ], exports: [RouterModule]
})
export class AppRoutingModule { }
